/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdIconProps } from './type';
const props: TdIconProps = {
  /** 图标颜色 */
  color: {
    type: String,
    value: '',
  },
  /** 图标名称或图片链接 */
  name: {
    type: String,
    value: '',
    required: true,
  },
  /** 自定义图标前缀 */
  prefix: {
    type: String,
    value: '',
  },
  /** 图标大小, 如 `20`, `20px`, `48rpx`, 默认单位是 `px` */
  size: {
    type: null,
  },
};

export default props;
